import { MediaQueryController } from "@theme/media-query-controller";

class ProductRecommendationsCarouselController extends MediaQueryController {
  connect() {
    if (
      this.activeBreakpoint === "small" ||
      this.activeBreakpoint === "medium"
    ) {
      this.initSwiper();
    }
    this.onWindowResize((activeBreakpoint) => {
      if (activeBreakpoint === "small" || activeBreakpoint === "medium") {
        this.initSwiper();
      } else {
        this.destroySwiper();
      }
    });
  }

  initSwiper() {
    if (this.swiper) {
      return;
    }
    this.swiper = new Swiper(this.element, {
      slidesPerView: "auto",
      spaceBetween: 10,
      pagination: {
        el: ".product-recommendations-carousel-pagination",
        clickable: true,
        bulletClass:
          "swiper-pagination-bullet tw:border tw:border-current tw:bg-transparent tw:opacity-100",
        bulletActiveClass: "tw:bg-current!",
      },
      autoplay: false,
    });
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

Stimulus.register(
  "product-recommendations-carousel",
  ProductRecommendationsCarouselController,
);
